/**
 * ScheduleLegend
 * ----------------
 * Displays the booked/open dot legend so users can quickly understand the
 * occupancy visualization.
 */
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const ScheduleLegend = () => (
  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
    <Stack direction="row" spacing={1} alignItems="center">
      <Box
        sx={{
          width: 14,
          height: 14,
          borderRadius: '50%',
          backgroundColor: 'primary.main',
          border: '1px solid primary.main',
        }}
      />
      <Typography variant="caption">Booked smasher</Typography>
    </Stack>
    <Stack direction="row" spacing={1} alignItems="center">
      <Box
        sx={{
          width: 14,
          height: 14,
          borderRadius: '50%',
          border: '1px dashed rgba(244,243,248,0.4)',
        }}
      />
      <Typography variant="caption">Open slot</Typography>
    </Stack>
  </Stack>
);

export default ScheduleLegend;